import { useMutation } from '@tanstack/react-query';
import { HubspotTypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';

export type UserUserUTMParametersReturnValue = {
    recordUserUTMParameters: (utmParameters: HubspotTypes.UTMParameters | null) => void;
};

export default function useUserUTMParameters(): UserUserUTMParametersReturnValue {
    const recordUserUTMParametersMutation = useMutation({
        mutationFn: async (utmParameters: HubspotTypes.UTMParameters | null) => {
            if (!utmParameters) return;
            return await appAPI.post(urls.api.users.userUTMParameters, {
                body: utmParameters,
            });
        },
    });

    return {
        recordUserUTMParameters: recordUserUTMParametersMutation.mutate,
    };
}
